import SearchEngineAdapter from 'Services/Adapters/SearchEngine/SearchEngineAdapter';
import SupportTicketStatus from 'Config/authenticated/SupportTicketStatus';

export default class SupportTicketAdapter extends SearchEngineAdapter {
    /**
     * Define statically the class key
     * Allows to determine the type of class without instantiating it
     */
    static get _key() {
        return 'ticket';
    }

    constructor(data = []) {
        super(data);
        this.key = SupportTicketAdapter._key;
    }

    getStructure() {
        return {
            key: this.key,
            label: window.i18n.__('Support'),
            icon: 'obj-slsy-support-emoji',
            count: 0,
            items: [],
        };
    }

    formatItem(item) {
        return {
            id: item.index,
            subject: item.subject,
            type: item.object.sub_type,
            status: {
                color: SupportTicketStatus[item.step].chipColor,
                label: SupportTicketStatus[item.step].label,
            },
            link: `/?_f=support_ticket&tid=${item.object.id}`,
            component: 'search-result-support',
            third: item.related[0],
        };
    }
}
